import _ from "lodash";
// Clevertap
// import clevertap from "clevertap-web-sdk";
import {
  IS_LOADING,
  IS_BTN_LOADING,
  IS_PROCESSING,
  SET_DATA,
  SET_PAGE_DATA,
  RESET_DATA,
  SET_STEP,
  REMOVE_DATA,
  SET_DIALOG,
} from "../types";
import api from "../../utils/api";
import { APPLICATION_STATUS } from "../../constants/applicationStatus";
import { EXPERIAN_DISPLAY_TYPE } from "../../constants/experian";
import { isLocalDebugMode } from "../../utils";
import { FEATURE_TOGGLE_ENABLE_BOOSTCONNECT_MANDATE, FEATURE_TOGGLE_ENABLE_REPAYMENT_EXISTING_FLOW, FEATURE_TOGGLE_ENABLE_JOURNEY_EXISTING_FLOW } from "../../constants/journey";

export const useActions = (state, dispatch) => {
  const showInvalidUrlDialog = () => {
    dispatch({
      type: SET_DIALOG,
      data: {
        dialog: {
          dialogTitle: "Error",
          dialogContent: "Invalid Url."
        },
        isDialogShow: true
      }
    });
  };

  const showErrorDialog = (error) => {
    dispatch({
      type: SET_DIALOG,
      data: {
        dialog: {
          dialogTitle: "Error",
          dialogContent: error?.data?.error?.message?.body ? error.data.error.message.body : "Something went wrong, Please try again later."
        },
        isDialogShow: true
      }
    });
  };

  const showCustomErrorDialog = (title, content) => {
    dispatch({
      type: SET_DIALOG,
      data: {
        dialog: {
          dialogTitle: title,
          dialogContent: content
        },
        isDialogShow: true
      }
    });
  };

  const terminateJourneyWithErrorPage = (error) => {
    dispatch({ type: SET_DATA, data: { currentPage: "error", errorPageError: error } });
  };

  const actions = {
    setLoading: (data) => {
      dispatch({ type: IS_LOADING, data });
    },
    setBtnLoading: (data) => {
      dispatch({ type: IS_BTN_LOADING, data });
    },
    setIsProcessing: (data) => {
      dispatch({ type: IS_PROCESSING, data });
    },
    setStep: (data) => {
      dispatch({ type: SET_STEP, data });
    },
    setData: (data, name) => {
      dispatch({ type: SET_DATA, data, name });
    },
    setPageData: (data, name) => {
      dispatch({ type: SET_PAGE_DATA, data, name });
    },
    removeData: (name) => {
      dispatch({ type: REMOVE_DATA, name });
    },
    resetData: () => {
      dispatch({ type: RESET_DATA });
    },
    setDialog: (data) => {
      dispatch({ type: SET_DIALOG, data });
    },
    showInvalidUrlDialog,
    terminateJourneyWithErrorPage,
    showCustomErrorDialog,
    cancelPayment: () => {
      dispatch({ type: IS_LOADING, data: true });
      return api.putPartner("/bnpl-gateway/checkout/cancel", {}, { Authorization: state.pToken }).then((res) => {
        window.location.href = res.data.redirectURL;
      }).catch((error) => {
        dispatch({ type: IS_LOADING, data: false });
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    prerequisites: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      const { clientId } = data;
      const dynamicPath = api.injectQueryParamString("/paylater/onboarding/prerequisite", {
        clientId
      });

      // DEV
      if (isLocalDebugMode()) {
        const res = {
          data: {
            "product": {
              "productId": "8888",
              "name": "Boost PayLater",
              "logoUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20211115/logo/b3e03fb1-22ca-49ba-8a5b-7587231d6ee2/boost_paylater_3x.png/3x"
            },
            "merchant": {
              "name": "Boost PayLater - Boost Life",
              "logoUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20211115/logo/b3e03fb1-22ca-49ba-8a5b-7587231d6ee2/boost_paylater_3x.png/3x",
              "termsOfUseUrl": "https://aspirasi-assets.s3.ap-southeast-1.amazonaws.com/aspirasi-paylater/rb/TOU_Boost_Credit_General.pdf",
              "privacyNoticeUrl": "https://aspirasi-assets.s3.ap-southeast-1.amazonaws.com/aspirasi-paylater/rb/PRN_Boost_Credit_General.pdf",
              "termAndConditionUrl": "https://aspirasi-assets.s3.ap-southeast-1.amazonaws.com/boost-credit/Terms+and+Conditions+Syariah_Boost+PayFlex+x+eCode_12072023.pdf",
              "faqUrl": "https://myboost.co/boost-payflex#faq-section"
            },
            "journeyConfigurations": {
              "global": {
                "skipProductPage": true,
                "skipVerifyMsisdnOtp": true,
                "skipPassword": true,
                "skipAddress": true,
                "skipKyc": true,
                "skipShareLocation": true,
                "confirmTransactionOtpRequired": false,
                "skipEmploymentDetails": true
              },
              "homePage": {
                "bannerUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20211115/logo/b3e03fb1-22ca-49ba-8a5b-7587231d6ee2/boost_paylater_3x.png/3x",
                "header": {
                  "en": "Powered by Boost Credit",
                  "ms": "Powered by Boost Credit"
                },
                "title": {
                  "en": "Enjoy Now, Pay Later",
                  "ms": "Nikmati Sekarang, Bayar Kemudian"
                },
                "body": {
                  "description": {
                    "en": "Pay your Bills and Prepaid 30 days later with zero charges.",
                    "ms": "Bayar Bil dan Prepaid anda 30 hari kemudian dengan zero charges."
                  },
                  "essential": {
                    "title": {
                      "en": "Features",
                      "ms": "Ciri-ciri"
                    },
                    "items": [
                      {
                        "iconUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20210818/icon/98d1e67a-d463-4c2e-ab7c-13cc000012b1/promotion_badge_boost.svg",
                        "descriptionAsHtml": {
                          "en": "Zero Interest Rate",
                          "ms": "Kadar Faedah Kosong"
                        }
                      },
                      {
                        "iconUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20210818/icon/e1dd0c70-bde2-483c-be94-f4f3b25403b5/stamp_badge_boost.svg",
                        "descriptionAsHtml": {
                          "en": "Instant approval with no collaterals",
                          "ms": "Kelulusan serta-merta tanpa cagaran"
                        }
                      },
                      {
                        "iconUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/boostcredit/logo/20220218/icon/ad8a432c-52ed-4008-8f65-e9945fb3773a/calender.svg",
                        "descriptionAsHtml": {
                          "en": "Pay later in 30 days",
                          "ms": "Bayar kemudian dalam 30 hari"
                        }
                      }
                    ]
                  },
                  "button": {
                    "submit": {
                      "show": true,
                      "displayText": {
                        "en": "APPLY NOW",
                        "ms": "MOHON SEKARANG"
                      }
                    },
                    "return": {
                      "show": false,
                      "displayText": {
                        "en": "RETURN",
                        "ms": "KEMBALI"
                      }
                    }
                  }
                },
                "hideLogo": true
              },
              "confirmApplicationPage": {
                "headerImageUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20210728/icon/6d8c45a3-217e-4a32-a04a-7a45b85c5f3a/superwoman.svg",
                "title": {
                  "en": "Hooray!",
                  "ms": "Hooray!"
                },
                "messageBody": {
                  "en": "Here is your PayFlex Spending Limit.",
                  "ms": "Berikut ialah Had Perbelanjaan PayFlex anda."
                },
                "consentHeader": {
                  "en": "To begin using Boost PayFlex, please consent to the following:",
                  "ms": ""
                },
                "consentBody": {
                  "en": "I declare that my total BNPL exposure across all BNPL providers, including my utilisation of Boost PayFlex, will not be more than RM1,500 at any given time.",
                  "ms": ""
                }
              },
              "completedApplicationPage": {
                "title": {
                  "en": "Thank you!",
                  "ms": ""
                },
                "messageBody": {
                  "en": "You can now transact via Boost PayFlex.<br/><br/>View your Boost PayFlex Dashboard under the ‘Boost PayFlex’ tile on the Main Page.",
                  "ms": ""
                }
              },
              "completedUpdateApplicationPage": {
                "title": {
                  "en": "Successful",
                  "ms": ""
                },
                "messageBody": {
                  "en": "Your information has been received successfully. Thank you!",
                  "ms": ""
                }
              }
            },
            "themingConfigurations": {
              "uiProperty": {
                "header": {
                  "background": "#FFFFFF",
                  "opacity": "1",
                  "font": {
                    "size": "14px",
                    "weight": "bold",
                    "alignment": "left",
                    "textTransform": "uppercase",
                    "color": "#8a8a8c",
                    "textDecoration": "none",
                    "textDecorationColor": "none"
                  }
                },
                "body": {
                  "background": "#F3F4F4",
                  "opacity": "1",
                  "heading": {
                    "font": {
                      "size": "28px",
                      "weight": "700",
                      "alignment": "left",
                      "textTransform": "capitalize",
                      "color": "#124A67",
                      "textDecoration": "none",
                      "textDecorationColor": "none"
                    }
                  },
                  "subHeading": {
                    "font": {
                      "size": "16px",
                      "weight": "normal",
                      "alignment": "left",
                      "textTransform": "none",
                      "color": "#124A67",
                      "textDecoration": "none",
                      "textDecorationColor": "none"
                    }
                  },
                  "content": {
                    "font": {
                      "size": "16px",
                      "weight": "normal",
                      "alignment": "left",
                      "textTransform": "none",
                      "color": "#124A67",
                      "textDecoration": "none",
                      "textDecorationColor": "none"
                    }
                  },
                  "stepNumber": {
                    "font": {
                      "size": "14px",
                      "weight": "700",
                      "alignment": "left",
                      "textTransform": "uppercase",
                      "color": "#ea0029",
                      "textDecoration": "none",
                      "textDecorationColor": "none"
                    }
                  },
                  "card": {
                    "template1": {
                      "font": {
                        "size": "16px",
                        "weight": "bold",
                        "alignment": "left",
                        "textTransform": "uppercase",
                        "color": "#3C3C3C",
                        "textDecoration": "none",
                        "textDecorationColor": "none"
                      },
                      "background": "#FFFFFF",
                      "boxShadow": "none",
                      "border": "none",
                      "borderRadius": "8px",
                      "opacity": "1"
                    },
                    "template2": {
                      "font": {
                        "size": "16px",
                        "weight": "bold",
                        "alignment": "left",
                        "textTransform": "uppercase",
                        "color": "#124A67",
                        "textDecoration": "none",
                        "textDecorationColor": "none"
                      },
                      "background": "#FFFFFF",
                      "boxShadow": "none",
                      "border": "1px solid #EFEFF6",
                      "borderRadius": "16px",
                      "opacity": "1"
                    }
                  },
                  "tab": {
                    "template1": {
                      "default": {
                        "background": "#FFFFFF",
                        "border": "1px solid #EFEFF6",
                        "borderRadius": "20px",
                        "opacity": "1",
                        "font": {
                          "size": "12px",
                          "weight": "normal",
                          "alignment": "center",
                          "textTransform": "none",
                          "color": "#124A67",
                          "textDecoration": "none",
                          "textDecorationColor": "none"
                        }
                      },
                      "active": {
                        "background": "#ea0029",
                        "font": {
                          "size": "12px",
                          "weight": "bold",
                          "alignment": "center",
                          "textTransform": "none",
                          "color": "#FFFFFF",
                          "textDecoration": "none",
                          "textDecorationColor": "none"
                        }
                      }
                    }
                  },
                  "button": {
                    "template1": {
                      "background": "#ea0029",
                      "border": "0px",
                      "borderRadius": "8px",
                      "opacity": "1",
                      "font": {
                        "size": "16px",
                        "weight": "bold",
                        "alignment": "center",
                        "textTransform": "uppercase",
                        "color": "#FFFFFF",
                        "textDecoration": "none",
                        "textDecorationColor": "none"
                      }
                    },
                    "template2": {
                      "background": "#FFFFFF",
                      "border": "1.5px solid #124A67",
                      "borderRadius": "8px",
                      "opacity": "1",
                      "font": {
                        "size": "16px",
                        "weight": "bold",
                        "alignment": "center",
                        "textTransform": "uppercase",
                        "color": "#124A67",
                        "textDecoration": "none",
                        "textDecorationColor": "none"
                      }
                    },
                    "template3": {
                      "background": "#FFFFFF",
                      "border": "1.5px solid #ea0029",
                      "borderRadius": "8px",
                      "opacity": "1",
                      "font": {
                        "size": "16px",
                        "weight": "bold",
                        "alignment": "center",
                        "textTransform": "uppercase",
                        "color": "#ea0029",
                        "textDecoration": "none",
                        "textDecorationColor": "none"
                      }
                    }
                  },
                  "progress": {
                    "linear": {
                      "template1": {
                        "variant": "determinate",
                        "type": "uniform",
                        "barColors": [
                          "#ea0029"
                        ],
                        "background": "#FFEDED",
                        "borderRadius": "8px",
                        "opacity": "1"
                      },
                      "template2": {
                        "variant": "determinate",
                        "type": "uniform",
                        "barColors": [
                          "#2BCB92"
                        ],
                        "background": "#05A0D3",
                        "borderRadius": "8px",
                        "opacity": "1"
                      },
                      "template3": {
                        "variant": "determinate",
                        "type": "multiple",
                        "barColors": [
                          "#ea0029",
                          "#FF8888",
                          "#FFEDED"
                        ],
                        "background": "#E5EDF0",
                        "borderRadius": "8px",
                        "opacity": "1"
                      }
                    }
                  },
                  "stepper": {
                    "template1": {
                      "default": {
                        "background": "#CECED5",
                        "border": "1px solid #CECED5",
                        "opacity": "1"
                      },
                      "active": {
                        "background": "#ea0029",
                        "border": "1px solid #ea0029",
                        "opacity": "1"
                      }
                    }
                  },
                  "pagination": {
                    "template1": {
                      "default": {
                        "background": "#FFFFFF",
                        "border": "1px solid #F1F2F6",
                        "borderRadius": "4px",
                        "opacity": "1",
                        "font": {
                          "size": "14px",
                          "weight": "normal",
                          "alignment": "center",
                          "textTransform": "uppercase",
                          "color": "#5A5F7D",
                          "textDecoration": "none",
                          "textDecorationColor": "none"
                        }
                      },
                      "active": {
                        "background": "#ea0029",
                        "borderRadius": "4px",
                        "opacity": "1",
                        "font": {
                          "size": "14px",
                          "weight": "normal",
                          "alignment": "center",
                          "textTransform": "uppercase",
                          "color": "#FFFFFF",
                          "textDecoration": "none",
                          "textDecorationColor": "none"
                        }
                      }
                    }
                  },
                  "dialog": {
                    "template1": {
                      "header": {
                        "background": "#FFEDED",
                        "font": {
                          "size": "14px",
                          "weight": "bold",
                          "alignment": "center",
                          "textTransform": "uppercase",
                          "color": "#ea0029",
                          "textDecoration": "none",
                          "textDecorationColor": "none"
                        }
                      },
                      "background": "#FFFFFF",
                      "boxShadow": "0px 3px 24px #ea002952",
                      "border": "1px solid #EFEFF6",
                      "borderRadius": "16px",
                      "opacity": "1"
                    }
                  },
                  "divider": {
                    "template1": {
                      "border": "1px solid #D5E3EB",
                      "opacity": "1"
                    }
                  },
                  "inputField": {
                    "textBox": {
                      "template1": {
                        "background": "#FFFFFF",
                        "borderRadius": "8px",
                        "border": "1px solid #8FB2C4",
                        "boxShadow": "0px 0px 6px #00000029",
                        "opacity": "1",
                        "font": {
                          "size": "14px",
                          "weight": "normal",
                          "alignment": "left",
                          "textTransform": "none",
                          "color": "#000000",
                          "textDecoration": "none",
                          "textDecorationColor": "none"
                        }
                      }
                    },
                    "selectBox": {
                      "template1": {
                        "background": "#F5F5FA",
                        "borderRadius": "8px",
                        "border": "1px solid #8FB2C4",
                        "opacity": "1",
                        "boxShadow": "0px 0px 6px #00000029",
                        "font": {
                          "size": "14px",
                          "weight": "normal",
                          "alignment": "left",
                          "textTransform": "none",
                          "color": "#333333",
                          "textDecoration": "none",
                          "textDecorationColor": "none"
                        }
                      }
                    },
                    "checkbox": {
                      "template1": {
                        "default": {
                          "background": "#FFFFFF",
                          "border": "1px solid #124A67",
                          "borderRadius": "4px",
                          "opacity": "1",
                          "font": {
                            "size": "14px",
                            "weight": "normal",
                            "alignment": "left",
                            "textTransform": "none",
                            "color": "#124A67",
                            "textDecoration": "none",
                            "textDecorationColor": "none"
                          }
                        },
                        "active": {
                          "background": "#005B8B",
                          "border": "1px solid #05A0D3",
                          "borderRadius": "4px",
                          "opacity": "1",
                          "font": {
                            "size": "14px",
                            "weight": "normal",
                            "alignment": "left",
                            "textTransform": "none",
                            "color": "#FFFFFF",
                            "textDecoration": "none",
                            "textDecorationColor": "none"
                          }
                        }
                      },
                      "template2": {
                        "default": {
                          "background": "#FFFFFF",
                          "border": "1px solid #99B5C5",
                          "borderRadius": "3px",
                          "opacity": "1",
                          "font": {
                            "size": "14px",
                            "weight": "normal",
                            "alignment": "left",
                            "textTransform": "none",
                            "color": "#124A67",
                            "textDecoration": "none",
                            "textDecorationColor": "none"
                          }
                        },
                        "active": {
                          "background": "#ea0029",
                          "border": "1px solid #ea0029",
                          "borderRadius": "3px",
                          "opacity": "1",
                          "font": {
                            "size": "14px",
                            "weight": "normal",
                            "alignment": "left",
                            "textTransform": "none",
                            "color": "#FFFFFF",
                            "textDecoration": "none",
                            "textDecorationColor": "none"
                          }
                        }
                      }
                    },
                    "radio": {
                      "template1": {
                        "default": {
                          "border": "1px solid #B8B8C1",
                          "background": "#EFEFF6",
                          "opacity": "1"
                        },
                        "active": {
                          "border": "1px solid #ea0029",
                          "background": "#ea0029",
                          "opacity": "1"
                        }
                      }
                    },
                    "toogle": {
                      "template1": {
                        "default": {
                          "background": "#FFFFFF",
                          "opacity": "1",
                          "border": "none",
                          "borderRadius": "none",
                          "boxShadow": "none",
                          "font": {
                            "size": "12px",
                            "weight": "normal",
                            "alignment": "center",
                            "textTransform": "uppercase",
                            "color": "#9491A1",
                            "textDecoration": "none",
                            "textDecorationColor": "none"
                          }
                        },
                        "active": {
                          "background": "#FFFFFF",
                          "opacity": "1",
                          "border": "none",
                          "borderRadius": "none",
                          "boxShadow": "none",
                          "font": {
                            "size": "12px",
                            "weight": "bold",
                            "alignment": "center",
                            "textTransform": "uppercase",
                            "color": "#ea0029",
                            "textDecoration": "underline",
                            "textDecorationColor": "#ea0029"
                          }
                        }
                      },
                      "template2": {
                        "default": {
                          "background": "#F5F5FA",
                          "opacity": "1",
                          "border": "1px solid #D5E3EB",
                          "borderRadius": "8px",
                          "boxShadow": "none",
                          "font": {
                            "size": "16px",
                            "weight": "normal",
                            "alignment": "center",
                            "textTransform": "none",
                            "color": "#333333",
                            "textDecoration": "none",
                            "textDecorationColor": "none"
                          }
                        },
                        "active": {
                          "background": "#124A67",
                          "opacity": "1",
                          "border": "1px solid #8FB2C4",
                          "borderRadius": "8px",
                          "boxShadow": "0px 0px 6px #00000029",
                          "font": {
                            "size": "16px",
                            "weight": "normal",
                            "alignment": "center",
                            "textTransform": "none",
                            "color": "#FFFFFF",
                            "textDecoration": "none",
                            "textDecorationColor": "none"
                          }
                        }
                      }
                    }
                  },
                  "scrollBar": {
                    "template1": {
                      "webkitScrollbarTrack": {
                        "boxShadow": "inset 0 0 10px 10px #FFEDED",
                        "borderRadius": "10px"
                      },
                      "webkitScrollbarThumb": {
                        "boxShadow": "inset 0 0 10px 10px #FF8888",
                        "borderRadius": "10px"
                      }
                    }
                  }
                },
                "footer": {
                  "background": "#EFEFF6",
                  "opacity": "1",
                  "font": {
                    "size": "12px",
                    "weight": "normal",
                    "alignment": "center",
                    "textTransform": "none",
                    "color": "#959595",
                    "textDecoration": "none",
                    "textDecorationColor": "none"
                  }
                }
              },
              "asset": {
                "headerBackgroundImageUrl": "none",
                "footerBackgroundImageUrl": "none",
                "dialogBackIconUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20210812/icon/3496e463-72c5-4f17-89c9-09a32470eb49/back_icon_red.svg",
                "checkIconUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20210812/icon/b3ee1ef3-fccf-4197-abc0-d69e28e5b23b/check_icon_boost.svg",
                "lockIconUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/paylater/assets/20210817/icon/0cb37674-336d-4f5d-a77d-2af6a74ad0ea/lock_icon_red.svg",
                "emptyFinancesImageUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/boostcredit/logo/20220223/icon/8d693938-29e5-4caa-8861-13e6eb4eff79/boost_empty.png",
                "emptyTransactionImageUrl": "https://aspirasi-static.s3.ap-southeast-1.amazonaws.com/boostcredit/logo/20220223/icon/8d693938-29e5-4caa-8861-13e6eb4eff79/boost_empty.png"
              }
            },
            "riskProfile": {
              "employmentStatuses": [
                {
                  "employmentStatusId": "1001",
                  "value": {
                    "en": "Unemployed",
                    "ms": "Menganggur"
                  },
                  "occupationRequired": false
                },
                {
                  "employmentStatusId": "1002",
                  "value": {
                    "en": "Student",
                    "ms": "Pelajar"
                  },
                  "occupationRequired": false
                },
                {
                  "employmentStatusId": "1003",
                  "value": {
                    "en": "Part time worker",
                    "ms": "Pekerja separuh masa"
                  },
                  "occupationRequired": true
                },
                {
                  "employmentStatusId": "1004",
                  "value": {
                    "en": "Full time worker",
                    "ms": "Pekerja sepenuh masa"
                  },
                  "occupationRequired": true
                },
                {
                  "employmentStatusId": "1005",
                  "value": {
                    "en": "Self-employed",
                    "ms": "Bekerja sendiri"
                  },
                  "occupationRequired": true
                },
                {
                  "employmentStatusId": "1006",
                  "value": {
                    "en": "Retired",
                    "ms": "Bersara"
                  },
                  "occupationRequired": false
                }
              ],
              "occupationTypes": [
                {
                  "occupationTypeId": "1001",
                  "value": {
                    "en": "Managers",
                    "ms": "Pengurus"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1002",
                  "value": {
                    "en": "Professional",
                    "ms": "Profesional"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1003",
                  "value": {
                    "en": "Technician and associate professionals",
                    "ms": "Juruteknik dan spara profesional"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1004",
                  "value": {
                    "en": "Clerical support workers",
                    "ms": "Pekerja sokongan perkeranian"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1005",
                  "value": {
                    "en": "Service and sales workers",
                    "ms": "Pekerja perkhidmatan dan penjualan"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1006",
                  "value": {
                    "en": "Skilled agricultural, forestry and fishery workers",
                    "ms": "Pekerja pertanian, perhutanan dan perikanan"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1007",
                  "value": {
                    "en": "Craft and related trades workers",
                    "ms": "Pekerja berkaitan seni dan perdagangan"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1008",
                  "value": {
                    "en": "Plant and machine operators, and assemblers",
                    "ms": "Pengendali kilang dan mesin, dan pemasangan"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1009",
                  "value": {
                    "en": "Elementary occupations",
                    "ms": "Pekerjaan asas"
                  },
                  "industryRequired": true
                },
                {
                  "occupationTypeId": "1010",
                  "value": {
                    "en": "Armed forces occupations",
                    "ms": "Pekerjaan ketenteraan"
                  },
                  "industryRequired": true
                }
              ],
              "industryCategories": [
                {
                  "industryCategoryId": "1000",
                  "value": {
                    "en": "Manufacturing",
                    "ms": "Pembuatan"
                  }
                },
                {
                  "industryCategoryId": "2000",
                  "value": {
                    "en": "Services",
                    "ms": "Perkhidmatan"
                  }
                },
                {
                  "industryCategoryId": "3000",
                  "value": {
                    "en": "Wholesale",
                    "ms": "Penjualan Borong"
                  }
                },
                {
                  "industryCategoryId": "4000",
                  "value": {
                    "en": "Accommodation & Hotel",
                    "ms": "Hotel & Penginapan"
                  }
                },
                {
                  "industryCategoryId": "5000",
                  "value": {
                    "en": "Food and Beverage",
                    "ms": "Makanan & Minuman"
                  }
                },
                {
                  "industryCategoryId": "6000",
                  "value": {
                    "en": "Advertising",
                    "ms": "Pengiklanan"
                  }
                },
                {
                  "industryCategoryId": "7000",
                  "value": {
                    "en": "Leisure & Travel",
                    "ms": "Percutian & Pelancongan"
                  }
                },
                {
                  "industryCategoryId": "8000",
                  "value": {
                    "en": "Education",
                    "ms": "Pendidikan"
                  }
                },
                {
                  "industryCategoryId": "9000",
                  "value": {
                    "en": "Health and Beauty",
                    "ms": "Kesihatan & Kecantikan"
                  }
                },
                {
                  "industryCategoryId": "10000",
                  "value": {
                    "en": "Entertainment & Lifestyle",
                    "ms": "Hiburan & Gaya Hidup"
                  }
                },
                {
                  "industryCategoryId": "11000",
                  "value": {
                    "en": "Retail",
                    "ms": "Penjualan runcit"
                  }
                },
                {
                  "industryCategoryId": "12000",
                  "value": {
                    "en": "Construction",
                    "ms": "Pembinaan"
                  }
                },
                {
                  "industryCategoryId": "13000",
                  "value": {
                    "en": "Financial Services",
                    "ms": "Perkhidmatan Kewangan"
                  }
                },
                {
                  "industryCategoryId": "14000",
                  "value": {
                    "en": "Transportation",
                    "ms": "Pengangkutan"
                  }
                },
                {
                  "industryCategoryId": "15000",
                  "value": {
                    "en": "Telecommunication",
                    "ms": "Telekomunikasi"
                  }
                },
                {
                  "industryCategoryId": "16000",
                  "value": {
                    "en": "Real Estate",
                    "ms": "Hartanah"
                  }
                },
                {
                  "industryCategoryId": "17000",
                  "value": {
                    "en": "Agriculture or Aquaculture",
                    "ms": "Pertanian atau Akuakultur"
                  }
                },
                {
                  "industryCategoryId": "18000",
                  "value": {
                    "en": "Online Shopping",
                    "ms": "Beli-belah Secara Online"
                  }
                },
                {
                  "industryCategoryId": "19000",
                  "value": {
                    "en": "Information and Technology",
                    "ms": "Teknologi dan Maklumat"
                  }
                },
                {
                  "industryCategoryId": "20000",
                  "value": {
                    "en": "Others",
                    "ms": "Lain-lain"
                  }
                }
              ],
              "monthlyIncomeRanges": [
                {
                  "monthlyIncomeId": "1001",
                  "value": {
                    "en": "Less than MYR2,000",
                    "ms": "Kurang daripada MYR2,000"
                  }
                },
                {
                  "monthlyIncomeId": "1002",
                  "value": {
                    "en": "MYR2,000 - MYR4,000",
                    "ms": "MYR2,000 - MYR4,000"
                  }
                },
                {
                  "monthlyIncomeId": "1003",
                  "value": {
                    "en": "MYR4,000 - MYR7,000",
                    "ms": "MYR4,000 - MYR7,000"
                  }
                },
                {
                  "monthlyIncomeId": "1004",
                  "value": {
                    "en": "MYR7,000 - MYR9,000",
                    "ms": "MYR7,000 - MYR9,000"
                  }
                },
                {
                  "monthlyIncomeId": "1005",
                  "value": {
                    "en": "MYR9,000 - MYR11,000",
                    "ms": "MYR9,000 - MYR11,000"
                  }
                },
                {
                  "monthlyIncomeId": "1006",
                  "value": {
                    "en": "MYR11,000 - MYR15,000",
                    "ms": "MYR11,000 - MYR15,000"
                  }
                },
                {
                  "monthlyIncomeId": "1007",
                  "value": {
                    "en": "More than MYR15,000",
                    "ms": "Lebih daripada MYR15,000"
                  }
                },
                {
                  "monthlyIncomeId": "1008",
                  "value": {
                    "en": "No source of income",
                    "ms": "Tiada pendapatan"
                  }
                }
              ],
              "maritalStatuses": [
                {
                  "maritalStatusId": "1001",
                  "value": {
                    "en": "Single",
                    "ms": "Bujang"
                  }
                },
                {
                  "maritalStatusId": "1002",
                  "value": {
                    "en": "Married",
                    "ms": "Berkahwin"
                  }
                },
                {
                  "maritalStatusId": "1003",
                  "value": {
                    "en": "Divorced",
                    "ms": "Bercerai"
                  }
                },
                {
                  "maritalStatusId": "1004",
                  "value": {
                    "en": "Widowed",
                    "ms": "Balu/Duda"
                  }
                }
              ],
              "noOfDependents": [
                {
                  "noOfDependentId": "1001",
                  "value": {
                    "en": "0",
                    "ms": "0"
                  }
                },
                {
                  "noOfDependentId": "1002",
                  "value": {
                    "en": "1",
                    "ms": "1"
                  }
                },
                {
                  "noOfDependentId": "1003",
                  "value": {
                    "en": "2",
                    "ms": "2"
                  }
                },
                {
                  "noOfDependentId": "1004",
                  "value": {
                    "en": "3 or more",
                    "ms": "3 atau lebih"
                  }
                }
              ]
            }
          }
        };
        dispatch({ type: SET_DATA, data: { prerequisites: res.data } });
        dispatch({ type: IS_LOADING, data: false });

        return new Promise((resolve) => resolve());
      }

      return api.get(dynamicPath).then((res) => {
        console.log("prerequisites", res);
        dispatch({ type: SET_DATA, data: { prerequisites: res.data } });
      }).catch((error) => {
        showErrorDialog(error);
        terminateJourneyWithErrorPage(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    getPostcodes: () => {
      dispatch({ type: IS_LOADING, data: true });
      return api.get("/paylater/onboarding/postcodes").then((res) => {
        console.log("getPostcodes", res);
        dispatch({ type: SET_DATA, data: { postcodes: res.data } });
      }).catch((error) => {
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    initialOnboarding: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      const { clientId } = state;
      const dynamicPath = api.injectQueryParamString("/paylater/onboarding/application", {
        clientId
      });

      // DEV
      if (isLocalDebugMode()) {
        const res = {
          data: {
            "applicationId": "2504237457973503",
            "status": "OTP_GENERATED",
            "generationDate": "2025-04-23T20:42:59+0800",
            "generationTimestamp": 1745412179000,
            "timeToLiveInMs": 180000
          }
        };

        dispatch({
          type: SET_DATA,
          data: {
            applicationId: res.data.applicationId,
            step: FEATURE_TOGGLE_ENABLE_JOURNEY_EXISTING_FLOW ? "Step2OTP" : "StepAdditionalDetails"
          }
        });
        return new Promise((resolve) => resolve());
      }

      return api.post(dynamicPath, data).then((res) => {
        console.log("initialOnboarding", res);
        dispatch({
          type: SET_DATA,
          data: {
            applicationId: res.data.applicationId,
            step: FEATURE_TOGGLE_ENABLE_JOURNEY_EXISTING_FLOW ? "Step2OTP" : "StepAdditionalDetails"
          }
        });
      }).catch((error) => {
        console.log("initialOnboarding error", error);
        if (error?.data.error?.code === 1626) {
          // PLS_HIGH_RISK_GRADE 1626
          dispatch({ type: SET_DATA, data: { step: "ScoringFailure" } });
        } else if ([1605, 1619, 1624, 1600, 1004].includes(error?.data.error?.code)) {
          /**
           * Non-Retry-able errorCodes, terminate journey
           * PLS_EXISTING_USER 1605
           * PLS_DEACTIVATED_APPLICATION_FOUND 1619
           * PLS_ACCOUNT_DISABLED 1624
           * PLS_RESEND_OTP_NOT_ALLOWED 1600
           * INVALID_ARGUMENT 1004
          */
          // showErrorDialog(error);
          dispatch({ type: SET_DATA, data: { step: "ScoringFailure" } });
        } else {
          /**
           * Retry-able errorCodes
           * & any other errorCodes not captured by previous IF clauses.
          */
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    validateOnboardOTP: (data) => {
      console.log("validateOnboardOTP data", data);
      dispatch({ type: IS_LOADING, data: true });
      return api.post("/paylater/onboarding/application/otp/validate", data).then((res) => {
        console.log("validateOnboardOTP", res);
        dispatch({ type: SET_DATA, data: { step: "Step3Password" } });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    resendOnboardOTP: (data) => {
      // dispatch({ type: IS_LOADING, data: true });
      return api.post("/paylater/onboarding/application/otp/resend", data).then((res) => {
        console.log("resendOnboardOTP", res);
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        // dispatch({ type: IS_LOADING, data: false });
      });
    },
    setPassword: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post("/paylater/onboarding/application/password", data).then((res) => {
        console.log("setPassword", res);
        dispatch({ type: SET_DATA, data: { kycToken: res.data.kycToken, customerId: res.data.customerId, applicationId: res.data.applicationId } });
        actions.getSessionToken(res.data.customerId, res.data.kycToken);
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    getSessionToken: (customerId, kycToken) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.get(`/customer/signin/session?customerId=${customerId}`, { Authorization: kycToken }).then((res) => {
        console.log("getSessionToken", res);
        // ls.set('sessionToken', res.data.sessionToken);
        dispatch({ type: SET_DATA, data: { sessionToken: res.data.sessionToken, step: "Step4Address" } });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    updateOnboarding: (data, retry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.put(`/paylater/onboarding/application?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("updateOnboarding", res);

        switch (state.step) {
          case "Step1PersonalDetails": {
            dispatch({
              type: SET_DATA,
              data: {
                step: FEATURE_TOGGLE_ENABLE_JOURNEY_EXISTING_FLOW ? "Step2OTP" : "StepAdditionalDetails"
              }
            });
            return res;
          }
          case "StepAdditionalDetails": {
            const nextStep = state.isOnboardingUpdate ? "ConsentInProgress" : "Step2OTP";

            dispatch({ type: SET_DATA, data: { step: nextStep } });
            return res;
          }
          case "Step4Address": {
            dispatch({ type: SET_DATA, data: { step: "Step5EmploymentDetails" } });
            return res;
          }
          case "Step5EmploymentDetails": {
            actions.confirmApplication({ applicationId: state.applicationId });
            return res;
          }
          default:
            return res;
        }

        // if (state.step === "Step5EmploymentDetails") {
        //   actions.confirmApplication({ applicationId: state.applicationId });
        // } else if (state.step === "Step1PersonalDetails") {
        //   dispatch({ type: SET_DATA, data: { step: "Step2OTP" } });
        // } else if (state.step === "Step4Address") {
        //   dispatch({ type: SET_DATA, data: { step: "Step5EmploymentDetails" } });
        // }
      }).catch((error) => {
        if (error?.status === 403 && retry) {
          getSessionToken().then((res) => {
            if (res) actions.updateOnboarding(data, false);
          });
        } else {
          showErrorDialog(error);

          // Note: Commenting this logic for now will be used in future.
          // if (state.step === "StepAdditionalDetails" && state.isOnboardingUpdate) {
          //   dispatch({ type: SET_DATA, data: { step: "ConsentFailed" } });
          // } else {
          //   showErrorDialog(error);
          // }
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    confirmApplication: (data, retry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post(`/paylater/onboarding/application/confirm?customerId=${state.customerId}`, {
        ...data,
        tncInd: true, // T&C consent flag
      }, { Authorization: state.sessionToken }).then((res) => {
        console.log("confirmApplication", res);
        dispatch({ type: SET_DATA, data: { applicationConfirmed: true } });
        dispatch({ type: SET_DATA, data: { step: "Step6KYC" } });
      }).catch((error) => {
        console.log("confirmApplication error", error);
        if (error?.status === 403 && retry) {
          getSessionToken().then((res) => {
            if (res) actions.confirmApplication(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    verifyKYC: (data, retry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post(`/paylater/onboarding/kyc?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("verifyKYC", res);
        if (res.data.status === APPLICATION_STATUS.KYC_SUCCESS) {
          dispatch({ type: SET_DATA, data: { step: "Step7ShareLocation" } });
        }
      }).catch((error) => {
        if (error?.status === 403 && retry) {
          getSessionToken().then((res) => {
            if (res) actions.verifyKYC(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    creditScoring: (data, retry = true) => {
      dispatch({ type: SET_DATA, data: { step: "ScoringLoading" } });
      return api.post(`/paylater/onboarding/scoring?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("creditScoring", res);
        if (res.data?.status === APPLICATION_STATUS.CREDIT_SCORE_SUCCESS) {
          dispatch({
            type: SET_DATA,
            data: {
              step: "Step8Mandate",
              eligibilityAmount: res.data.eligibilityAmount
            }
          });
        }
      }).catch((error) => {
        console.log("creditScoring error", error);
        if (error?.status === 403 && retry) {
          getSessionToken().then((res) => {
            if (res) actions.creditScoring(data, false);
          });
        } else if (error?.data.error?.code === 1659) {
          // PLS_CREDIT_SCORING_PENDING_INCOME_ASSESSMENT 1659
          getIncomeAssessmentUrl(state.applicationId, state.customerId);
        } else if (error?.data.error?.code === 1626) {
          // PLS_HIGH_RISK_GRADE 1626 (special handle)
          if (state.enableHighRiskQuestionnaire) {
            dispatch({ type: SET_DATA, data: { step: "StepHighRisk" } });
          } else {
            dispatch({ type: SET_DATA, data: { step: "ScoringFailure" } });
          }
        } else if ([1605, 1609].includes(error?.data.error?.code)) {
          /**
           * Show Scoring Failed page
           * PLS_EXISTING_USER 1605
           * PLS_CREDIT_SCORING_FAILED 1609
          */
          // showErrorDialog(error);
          dispatch({ type: SET_DATA, data: { step: "ScoringFailure" } });
        } else if ([1610, 1004].includes(error?.data.error?.code)) {
          /**
           * Non-Retry-able errorCodes, Show Scoring Failed page
           * PLS_CREDIT_SCORING_SERVER_ERROR 1610
           * INVALID_ARGUMENT 1004
          */
          // showErrorDialog(error);
          dispatch({ type: SET_DATA, data: { step: "ScoringFailure" } });
        } else if (error?.data.error?.code === 1001) {
          // Experian downtime at scoring: app submitted, limit delayed → ApplicationSubmittedDowntime
          dispatch({ type: SET_DATA, data: { step: "ApplicationSubmittedDowntime" } });
        } else if (error?.status >= 500) {
          // Temp Fix when backend down
          showErrorDialog(error);
          // showCustomErrorDialog("Error", "Sorry, we are not able to process your application right now. Please try again later");
          terminateJourneyWithErrorPage(error);
        } else {
          /**
           * Other errors
          */
          showErrorDialog(error);

          // return previous page before CCRIS check
          if (state.currentPage == "signUp" && state.step) {
            dispatch({ type: SET_DATA, data: { step: state.stepDefinition.alias.ScoringLoading } });
          }
        }
      });
    },
    initialMandate: (data, retry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post(`/paylater/onboarding/mandate/initiate?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("initialMandate", res);
        createFormPost(res.data.mandateUrl);
        // window.location.href = res.data.mandateUrl;
      }).catch((error) => {
        if (error?.status === 403 && retry) {
          getSessionToken().then((res) => {
            if (res) actions.initialMandate(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    getMandateStatus: (data, reTry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post(`/paylater/onboarding/mandate/status?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("getMandateStatus ", res.data.status);
        if (res.data.status === "APPROVED") {
          // dispatch({ type: SET_DATA, data: { step: "ConfirmSignUpOTP" } });
          const confirmPreAuthSubmissionData = {
            applicationId: state.applicationId,
          };
          actions.confirmPreAuthSubmission(confirmPreAuthSubmissionData);
        } else if (res.data.status === "PENDING") {
          _.debounce(() => {
            console.log("debounce ", "getMandateStatus");
            actions.getMandateStatus(data, true);
          }, 30000);
        } else if (res.data.status === "NOT_FOUND") {
          showCustomErrorDialog("Error", "Mandate status not found.");
        }
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.getMandateStatus(data, false);
          });
        } else if (error.status === 400 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.getMandateStatus(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    initialMandatev2: (data, retry = true) => {
      dispatch({ type: IS_LOADING, data: true });

      // DEV
      if (isLocalDebugMode()) {
        const res = {
          data: {
            // mandateUrl: "https://stage-pay.boostconnect.biz?t=7OqydOfyWEUOHHoJgBhBty"
            mandateUrl: `${window.location.href.split("?")[0]}?uuid=4f27ceb3-3ce2-465d-9ecb-93edc6b00a98&referenceId=jry05727-7j29-44u5-ah18-742732kt1et02&amount=1.00&currency=MYR&created=2025-04-23T09%253A21%253A02.477Z&description=&status=failed&timestamp=2025-04-23T09%253A21%253A48.039Z&signature=1j29eOQ9ei864Nt0a81WXI7L298kZ1pQQogdUxrB0yI=&debug=1`
          }
        };
        if (res.data.mandateUrl) {
          window.location.href = res.data.mandateUrl;
        }
        return new Promise((resolve) => resolve());
      }

      return api.post(`/paylater/onboarding/mandate/v2/initiate?customerId=${state.customerId}`, {
        ...data,
        applicationId: state.applicationId
      }, { Authorization: state.sessionToken }).then((res) => {
        console.log("initialMandatev2", res);
        if (res.data.mandateUrl) {
          window.location.href = res.data.mandateUrl;
        }
      }).catch((error) => {
        if (error?.status === 403 && retry) {
          getSessionToken().then((res) => {
            if (res) actions.initialMandatev2(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      }).finally(() => {
        // continue showing loading spinner unless error occur
        // dispatch({ type: IS_LOADING, data: false });
      });
    },
    getMandateStatusv2: (data, callback = null, reTry = true) => {
      // DEV
      if (isLocalDebugMode()) {
        const res = {
          data: {
            status: "APPROVED" // FAILED, APPROVED, PENDING, INITIATED
          }
        };
        callback?.(res.data);
        return new Promise((resolve) => resolve());
      }

      return api.post(`/paylater/onboarding/mandate/v2/status?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.debug("getMandateStatusv2 ", res.data.status);
        callback?.(res.data);
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.getMandateStatusv2(data, callback, false);
          });
        } else if (error.status === 400 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.getMandateStatusv2(data, callback, false);
          });
        } else {
          showErrorDialog(error);
        }
      });
    },
    resendContractOTP: (data, reTry = true) => {
      return api.post(`/paylater/onboarding/contract/otp?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("resendContractOTP", res);
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.resendContractOTP(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      });
    },
    verifyContractOTP: (data, reTry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post(`/paylater/onboarding/contract/otp/validate?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("verifyContractOTP", res);
        const confirmPreAuthSubmissionData = {
          applicationId: state.applicationId,
        };
        actions.confirmPreAuthSubmission(confirmPreAuthSubmissionData);
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.verifyContractOTP(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    confirmPreAuthSubmission: (data, reTry = true) => {
      dispatch({ type: IS_LOADING, data: true });

      // DEV
      if (isLocalDebugMode()) {
        const res = {
          data: {
            status: "CONSENT_PENDING",
            eligibilityAmount: 1000,
            requireConsentFlag: true
          }
        };
        handleApplicationStatus(state.applicationId, res.data.status, res.data.eligibilityAmount, res.data.requireConsentFlag);
        return new Promise((resolve) => resolve());
      }

      return api.post(`/paylater/onboarding/contract/confirm?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("confirmPreAuthSubmission", res);

        handleApplicationStatus(state.applicationId, res.data.status, res.data.eligibilityAmount, res.data.requireConsentFlag);
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.confirmPreAuthSubmission(data, false);
          });
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    updateLimitConsent: (data, reTry = true) => {
      dispatch({ type: IS_LOADING, data: true });

      // DEV:
      // if (state.debug) {
      //   dispatch({ type: SET_DATA, data: { applicationStatus: APPLICATION_STATUS.SUCCESS, step: "ConsentConfirmed" } });
      //   dispatch({ type: IS_LOADING, data: false });
      //   return new Promise((resolve) => resolve());
      // }

      return api.put(`/paylater/onboarding/limit/consent?customerId=${state.customerId}`, {
        ...data,
        applicationId: state.applicationId
      }, { Authorization: state.sessionToken }).then((res) => {
        console.log("updateLimitConsent", res);

        // PayFlex send clevertap event after consent
        // clevertap.event.push("BNPL_ACTIVATED", {});

        dispatch({ type: SET_DATA, data: { applicationStatus: APPLICATION_STATUS.SUCCESS, step: "ConsentConfirmed" } });
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.updateLimitConsent(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    signIn: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post("/customer/signin", data).then((res) => {
        if (res.status === 200) {
          // ls.set("kycToken", res.data.kycToken);
          state.customerId = res.data.customerId;
          state.kycToken = res.data.kycToken;
          actions.startTransaction();
          // dispatch({ type: SET_DATA, data : { customerId: res.data.customerId, kycToken: res.data.kycToken }});
        }
      }).catch((error) => {
        dispatch({ type: IS_LOADING, data: false });
        console.log("signIn error", error);
        if (error.data?.error.code === 1310) {
          dispatch({ type: SET_DATA, data: { credential: data, step: "SignInOTP" } });
          // {"status":{"code":400,"message":"HTTP 400 - Invalid request message!"},"error":{"code":1310,"message":{"style":"NONE","body":"6-digit OTP is required to proceed."}}}
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {

      });
    },
    signInResendOTP: (data, reTry = true) => {
      return api.post("/customer/signin/otp/resend", data).then((res) => {
        console.log("signInResendOTP", res);
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.signViaOTP(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      });
    },
    signInViaOTP: (data, reTry = true) => {
      return api.post("/customer/signin/otp/validate", data).then((res) => {
        console.log("signInViaOTP", res);
        if (res.status === 200) {
          // ls.set("kycToken", res.data.kycToken);
          state.customerId = res.data.customerId;
          state.kycToken = res.data.kycToken;
          state.credential = null;
          actions.startTransaction();
          // dispatch({ type: SET_DATA, data : { customerId: res.data.customerId, kycToken: res.data.kycToken }});
        }
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.signViaOTP(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      });
    },
    forgotPassword: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post("/customer/reset/password", data).then((res) => {
        dispatch({ type: SET_DATA, data: { step: "ForgotPasswordOTP" } });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    forgotPasswordResendOTP: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post("/customer/reset/password/otp/resend", data).then((res) => {

      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    forgotPasswordValidateOTP: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post("/customer/reset/password/otp/validate", data).then((res) => {
        dispatch({ type: SET_DATA, data: { step: "NewPassword", kycToken: res.data.kycToken, customerId: res.data.customerId } });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    resetPassword: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.put(`/customer/reset/password?customerId=${state.customerId}`, data, { Authorization: state.kycToken }).then((res) => {
        dispatch({ type: SET_DATA, data: { step: "PasswordSuccess" } });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    getSupplementary: (data, reTry = true) => {
      return api.get(`/paylater/transaction/supplementary?customerId=${state.customerId}&transactionId=${state.transaction.transactionId}&principal=${data.principal}&tenure=${data.tenure}&timeUnit=${data.timeUnit}`, { Authorization: state.sessionToken }).then((res) => {
        console.log("getSupplementary", res);
        if (res.data && res.data.length > 0) {
          dispatch({ type: SET_DATA, data: { supplementary: res.data[0], step: "Insurance" } });
        } else {
          const params = {
            transactionId: state.transaction.transactionId,
            paymentPlan: {
              timeUnit: data.timeUnit,
              tenure: data.tenure
            },
            supplementaryServiceIds: []
          };
          actions.updatePreviewTransaction(params);
        }
      }).catch((error) => {
        console.log("getSupplementary error", error);
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.getSupplementary(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      });
    },
    updatePreviewTransaction: (data, reTry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.put(`/paylater/transaction/preview?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("updatePreviewTransaction", res);
        dispatch({ type: SET_DATA, data: { preview: res.data } });
        if (state.skipInitiationAgreement === false) {
          actions.getInitiationAgreement();
        } else {
          dispatch({ type: SET_DATA, data: { step: "Contract" } });
        }
      }).catch((error) => {
        console.log("updatePreviewTransaction error", error);
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.updatePreviewTransaction(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    acceptTransaction: (data, reTry = true) => {
      return api.post(`/paylater/transaction/accept?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("acceptTransaction", res);

        if (res.status === 200) {
          dispatch({ type: SET_DATA, data: { step: "ContractOTP" } });
        }
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.acceptTransaction(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      });
    },
    transactionValidateOTP: (data, reTry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post(`/paylater/transaction/otp/validate?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("transactionValidateOTP", res);
        actions.setStep("Processing");
        actions.confirmTransaction({ transactionId: data.transactionId, paymentPlan: { timeUnit: data.paymentPlan.timeUnit, tenure: data.paymentPlan.tenure } });
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.transactionValidateOTP(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    transactionResendOTP: (data, reTry = true) => {
      return api.post(`/paylater/transaction/otp/resend?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("transactionResendOTP", res);
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.transactionResendOTP(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      });
    },
    confirmTransaction: (data, reTry = true) => {
      return api.post(`/paylater/transaction/confirm?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
        console.log("confirmTransaction", res);
        dispatch({ type: IS_LOADING, data: false });
        dispatch({ type: SET_DATA, data: { step: "SuccessfulPayment", IS_LOADING: false } });
      }).catch((error) => {
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.confirmTransaction(data, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      });
    },
    startTransaction: () => {
      dispatch({ type: IS_LOADING, data: true });
      getSessionToken().then((respond) => {
        if (respond) {
          if (state.pToken) {
            // online
            getTransactionToken();
          } else if (state.pMode == "offline") {
            // offline purchase
            getOfflineTransactionToken();
          }
        }
      });
    },
    getInitiationAgreement: (data, reTry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.get(`/paylater/transaction/initiationAgreement?customerId=${state.customerId}&transactionId=${state.transaction.transactionId}`, { Authorization: state.sessionToken }).then((res) => {
        console.log("getInitiationAgreement", res);
        if (res.data.skipInitiationAgreement === false) {
          dispatch({ type: SET_DATA, data: { initiationAgreement: res.data, step: "WakalahContract" } });
        } else {
          dispatch({ type: SET_DATA, data: { step: "Contract" } });
        }
      }).catch((error) => {
        console.log("getInitiationAgreement error", error);
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.getInitiationAgreement(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    acceptInitiationAgreement: (data, reTry = true) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post(`/paylater/transaction/initiationAgreement/accept?customerId=${state.customerId}`, { transactionId: state.transaction.transactionId }, { Authorization: state.sessionToken }).then((res) => {
        console.log("acceptInitiationAgreement", res);
        dispatch({ type: SET_DATA, data: { step: "Contract" } });
      }).catch((error) => {
        console.log("acceptInitiationAgreement error", error);
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) actions.acceptInitiationAgreement(data, false);
          });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    getPiiData: () => {
      dispatch({ type: IS_LOADING, data: true });

      // DEV
      if (isLocalDebugMode()) {
        const res = {
          data: {
            // Use empty object to simulate no prefill data (user fills manually):
            // "additionalDetails": {},
            "additionalDetails": {
              "maritalStatus": "Single",
              "race": "Malay",
              "bumiputeraStatus": "BUMIPUTERA",
              "employerName": "test",
              "epfContribution": "MANDATORY_ONLY"
            },
            "annualIncomeRange": {
              "end": 100000,
              "start": 50000
            },
            "businessCategory": {
              "categoryId": 5000,
              "subCategoryId": 0
            },
            "clientId": "8888",
            "fullName": "Some Full Name",
            "nric": "880808088888",
            "email": "example@myboost.co",
            "msisdn": "60123456789",
            "employmentStatusId": "1004",
            "homeAddress": {
              "addressLine1": "Block A, Jalan Satu",
              "addressLine2": "Taman Dua",
              "addressLine3": "",
              "city": "petaling jaya",
              "postcode": "47600",
              "state": "selangor"
            },
            "idNumber": "880808088888",
            "idType": "NRIC",
            "natureOfBusiness": "Food & Beverage",
            "occupation": "Waiter / Waitress",
            "occupationTypeId": "1002",
            "uid": "63db7d33e95bcb3e697902d8"
          }
        };
        console.log("getPiiData", res);
        dispatch({
          type: SET_DATA,
          data: {
            piiData: res.data,
            ...((!FEATURE_TOGGLE_ENABLE_JOURNEY_EXISTING_FLOW && !state.isOnboardingUpdate) && { step: "Step1PersonalDetails" }),
            isBoostJourney: !!res.data
          }
        });
      }

      const dynamicPath = api.injectQueryParamString("/paylater/onboarding/piiData", {
        customerId: state.customerId,
        applicationId: state.applicationId,
        ...((!FEATURE_TOGGLE_ENABLE_JOURNEY_EXISTING_FLOW && state.isOnboardingUpdate) && { update: state.isOnboardingUpdate })
      });

      return api.get(dynamicPath, { Authorization: state.sessionToken }).then((res) => {
        console.log("getPiiData", res);
        dispatch({
          type: SET_DATA,
          data: {
            piiData: res.data,
            ...((!FEATURE_TOGGLE_ENABLE_JOURNEY_EXISTING_FLOW && !state.isOnboardingUpdate) && { step: "Step1PersonalDetails" }),
            isBoostJourney: !!res.data
          }
        });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    getKycToken: () => {
      dispatch({ type: IS_LOADING, data: true });

      // Prevent showing empty form too fast for pages that require API before rendering
      const pagesRequiringApiBeforeRender = ["Step1PersonalDetails", "PartnershipConfirmation"];

      if (pagesRequiringApiBeforeRender.includes(state.step)) {
        actions.setStep(null); // prevent showing empty form too fast
      }

      // const url = FEATURE_TOGGLE_ENABLE_BOOSTCONNECT_MANDATE ? "/paylater/monitoring/v2/configuration" : "/paylater/monitoring/configuration";

      let url = "";

      if (FEATURE_TOGGLE_ENABLE_REPAYMENT_EXISTING_FLOW) {
        url = FEATURE_TOGGLE_ENABLE_BOOSTCONNECT_MANDATE ? "/paylater/monitoring/v2/configuration" : "/paylater/monitoring/configuration";
      } else {
        url = "/paylater/monitoring/v2/configuration";
      }

      // DEV
      if (isLocalDebugMode()) {
        const res = {
          data: {
            // "kycToken": "abc",
            // "customerId": "2410233472993407",
            // "status": APPLICATION_STATUS.CUSTOMER_CREATED
            "customerId": "2504148422519087",
            "kycToken": "eyJhbGciOiJSUzI1NiJ9.eyJleHBpcnlJbk1pbGxpU2Vjb25kcyI6LTEwMDAsImNyZWF0ZVRpbWUiOjE3NjA2MDI1NjAxNzQsInNlY3JldCI6Ijk1MGFPZXZGSEk0alpFdmNESlNYazJoTWdwdEJZczNUSU5MNFpobEJOMVk2SVBaSDdvRU1LUHVnQU1NbkppV25BZ25samtTQ3hzbVNLL1UwWVZ3M093PT0ifQ.FT1sWnN_f5Kdi1sOuRCaW65-Izfi1X-8TwiNFcH-FhIlTBPWVShjvMMzoo0i5Whr4NSP_5b-UM5r2O_o2Y6izUK4dMJr_fqSK3x3tM__PRVqQxvp2kfM1F8Tyy0Fv_zIgfQeGs-vmiGQp87PizR2e2_l4K27rdYhrbKh8YqbW1zKpP_lfj5tODny3VYx1AIS4hKuL5pXViCSDB3-y3AorPFD4rcCSiDgOtw6SLeNJ9Tb4Hw-m94Ko7YW-mA4Fmj4EocP53ocDle36mg7j6hmMyOY2lbNbvjh9aut-LbJjm73RWs-72D-4465q6A4uiKQ9jJRomcNvbKIAmwPYbnqmw",
            "timeToLiveInMs": -1,
            "generationTimestamp": 1760602560000,
            "generationDate": "2025-10-16T16:16:00+0800",
            "configurations": {
              "applicationId": "2504148422402296",
              "clientId": "2206074425770004",
              "portalTemplate": "TEMPLATE_TWO_RED"
            },
            "experian": {
              "downtimeFlag": true,
              "startTime": "13:00", // it wont return if downtimeFlag is false
              "endTime": "14:00", // it wont return if downtimeFlag is false
              "displayType": EXPERIAN_DISPLAY_TYPE.BANNER
            },
            // status → page (getKycToken resume):
            // SUCCESS, CONSENT_PENDING → ApplicationSubmitted
            // CREDIT_SCORE_PENDING_CCRIS → ApplicationSubmittedDowntime
            // CREDIT_SCORE_SUCCESS_INCOME_ASSESSMENT → Step8Mandate
            // MANDATE_PENDING → Step8Mandate | MandatePending
            // MANDATE_FAILED → MandateFailure
            // MANDATE_APPROVED → MandateLoading
            // other → getPiiData (form steps)
            "status": "SUCCESS",
            "requireConsentFlag": false,
          }
        };
        state.kycToken = res.data.kycToken;
        state.customerId = res.data.customerId;
        dispatch({
          type: SET_DATA,
          data: {
            kycToken: res.data.kycToken,
            customerId: res.data.customerId,
            experian: res.data?.experian || null // Must set in order to trigger ExperianBanner on form steps
          }
        });

        // Experian SCREEN: full-page maintenance, block onboarding (BANNER → ExperianBanner on form steps)
        if (res.data?.experian?.downtimeFlag === true && res.data?.experian?.displayType === EXPERIAN_DISPLAY_TYPE.SCREEN) {
          actions.setStep("MaintenancePage");
          return;
        }

        getSessionToken().then((getSessionTokenRes) => {
          // resume journey
          if ([APPLICATION_STATUS.CONSENT_PENDING, APPLICATION_STATUS.MANDATE_APPROVED].includes(res.data.status)) {
            handleApplicationStatus(state.applicationId, res.data.status, res.data.eligibilityAmount, res.data.requireConsentFlag);
          } else if (res.data.status == APPLICATION_STATUS.CREDIT_SCORE_PENDING_CCRIS) {
            // Experian downtime at scoring: app submitted, limit delayed → ApplicationSubmittedDowntime
            actions.setStep("ApplicationSubmittedDowntime");
          }
          // else if (res.data.status == APPLICATION_STATUS.CREDIT_SCORE_PENDING_INCOME_ASSESSMENT) {
          //   // proceed to IA journey
          //   getIncomeAssessmentUrl(state.applicationId, state.customerId);
          // }
          else if (res.data.status == APPLICATION_STATUS.CREDIT_SCORE_SUCCESS_INCOME_ASSESSMENT) {
            // proceed to mandate
            actions.setStep("Step8Mandate");
          } else if (res.data.status == APPLICATION_STATUS.MANDATE_PENDING) {
            if (!FEATURE_TOGGLE_ENABLE_REPAYMENT_EXISTING_FLOW) {
              actions.setStep("Step8Mandate");
            } else {
              actions.setStep("MandatePending");
            }
          } else if (res.data.status == APPLICATION_STATUS.MANDATE_FAILED) {
            actions.setStep("MandateFailure");
          } else if (getSessionTokenRes) { actions.getPiiData(); }
        });
        return new Promise((resolve) => resolve());
      }

      return api.get(`${url}?loginToken=${state.lToken}&applicationId=${state.applicationId}`).then((res) => {
        state.kycToken = res.data.kycToken;
        state.customerId = res.data.customerId;
        dispatch({
          type: SET_DATA,
          data: {
            kycToken: res.data.kycToken,
            customerId: res.data.customerId,
            experian: res.data?.experian || null
          }
        });

        // Experian SCREEN: full-page maintenance, block onboarding (BANNER → ExperianBanner on form steps)
        if (res.data?.experian?.downtimeFlag === true && res.data?.experian?.displayType === EXPERIAN_DISPLAY_TYPE.SCREEN) {
          actions.setStep("MaintenancePage");
          return;
        }

        getSessionToken().then((getSessionTokenRes) => {
          // resume journey
          if ([APPLICATION_STATUS.CONSENT_PENDING, APPLICATION_STATUS.MANDATE_APPROVED].includes(res.data.status)) {
            handleApplicationStatus(state.applicationId, res.data.status, res.data.eligibilityAmount, res.data.requireConsentFlag);
          } else if (res.data.status == APPLICATION_STATUS.CREDIT_SCORE_PENDING_CCRIS) {
            // Experian downtime at scoring: app submitted, limit delayed → ApplicationSubmittedDowntime
            actions.setStep("ApplicationSubmittedDowntime");
          }
          // else if (res.data.status == APPLICATION_STATUS.CREDIT_SCORE_PENDING_INCOME_ASSESSMENT) {
          //   // proceed to IA journey
          //   getIncomeAssessmentUrl(state.applicationId, state.customerId);
          // }
          else if (res.data.status == APPLICATION_STATUS.CREDIT_SCORE_SUCCESS_INCOME_ASSESSMENT) {
            // proceed to mandate
            actions.setStep("Step8Mandate");
          } else if (res.data.status == APPLICATION_STATUS.MANDATE_PENDING) {
            if (!FEATURE_TOGGLE_ENABLE_REPAYMENT_EXISTING_FLOW) {
              actions.setStep("Step8Mandate");
            } else {
              actions.setStep("MandatePending");
            }
          } else if (res.data.status == APPLICATION_STATUS.MANDATE_FAILED) {
            actions.setStep("MandateFailure");
          } else if (getSessionTokenRes) { actions.getPiiData(); }
        });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    getBankList: () => {
      dispatch({ type: IS_LOADING, data: true });
      return api.get("/paylater/onboarding/banks").then((res) => {
        dispatch({ type: SET_DATA, data: { banks: res.data } });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    getHighRiskQuestionnaire: () => {
      dispatch({ type: IS_LOADING, data: true });
      return api.get(
        `/paylater/onboarding/assessment/questionnaire?applicationId=${state.applicationId}&customerId=${state.customerId}`, { Authorization: state.sessionToken }
      ).then((res) => {
        dispatch({ type: SET_DATA, data: { highRisk: res.data } });
      }).catch((error) => {
        showErrorDialog(error);
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    performHighRiskGrading: (data) => {
      dispatch({ type: IS_LOADING, data: true });
      return api.post(
        `/paylater/onboarding/assessment/grade?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }
      ).then((res) => {
        console.log("performHighRiskGrading", res);
        if (res.data?.status === APPLICATION_STATUS.CREDIT_SCORE_SUCCESS) {
          dispatch({
            type: SET_DATA,
            data: {
              step: "Step8Mandate",
              eligibilityAmount: res.data.eligibilityAmount
            }
          });
        }
      }).catch((error) => {
        console.log("performHighRiskGrading error", error);
        if (error?.data.error?.code === 1626) {
          dispatch({ type: SET_DATA, data: { step: "ScoringFailure" } });
        } else {
          showErrorDialog(error);
        }
      }).finally(() => {
        dispatch({ type: IS_LOADING, data: false });
      });
    },
    initiateOfflineTransaction: (data) => {
      state.transactionAmount = data.amount;
      state.metadata = {
        ...state.metadata,
        userNotes: data.notes
      };
      initiateTransaction();
    },
    getDashboardUrl: () => {
      // dispatch({ type: IS_LOADING, data: true });

      // DEV
      if (isLocalDebugMode()) {
        const res = {
          data: {
            "applicationId": "2404225623573194",
            "redirectionUrl": "https://paylater-uat.aspirasi.co/dashboard/?clientId=4&applicationId=2404225623573194&lToken=eyJhbGciOiJIUzI1NiJ9.eyJleHBpcnlJbk1pbGxpU2Vjb25kcyI6MTgwMDAwLCJjcmVhdGVUaW1lIjoxNzU5OTgwMzg1NzQ2LCJzZWNyZXQiOiI5NTBhT2V2RkhJNGpaRXZjREpTWGt3eWVZd0l6Y2orRzRQZGM2aGZNb3ZwVEFaT0RtZ1FWb1ZPYXdKS1Yyc0ZMK0tyTXVINWtzWmhSdVBJSjdJWDhPRG9GS2VQNHdxaTZITE5oSkx1Nm9Jdz0ifQ.ZE_5ltEgC_fVM1B0twSsxyG7LEDxCG6N13cxKP1ulcQ",
            "headers": [
              {
                "Authorization": "eyJhbGciOiJIUzI1NiJ9.eyJleHBpcnlJbk1pbGxpU2Vjb25kcyI6MTgwMDAwLCJjcmVhdGVUaW1lIjoxNzU5OTgwMzg1NzQ2LCJzZWNyZXQiOiI5NTBhT2V2RkhJNGpaRXZjREpTWGt3eWVZd0l6Y2orRzRQZGM2aGZNb3ZwVEFaT0RtZ1FWb1ZPYXdKS1Yyc0ZMK0tyTXVINWtzWmhSdVBJSjdJWDhPRG9GS2VQNHdxaTZITE5oSkx1Nm9Jdz0ifQ.ZE_5ltEgC_fVM1B0twSsxyG7LEDxCG6N13cxKP1ulcQ"
              }
            ],
            "timeToLiveInMs": 180000,
            "generationTimestamp": 1759980385746,
            "generationDate": "2025-10-09T11:26:25+0800"
          }
        };

        return new Promise((resolve) => resolve(res));
      }

      return api.get(`/paylater/dashboard/url?customerId=${state.customerId}&applicationId=${state.applicationId}`, { Authorization: state.sessionToken }).then((res) => {
        console.log("getDashboardUrl", res);
        dispatch({ type: SET_DATA, data: { dashboardUrl: res.data.redirectionUrl } });

        return res;
      }).catch((error) => {
        showErrorDialog(error);
      });
      // .finally(() => {
      //   dispatch({ type: IS_LOADING, data: false });
      // });
    },
  };

  const getIncomeAssessmentUrl = (applicationId, customerId, reTry = true) => {
    dispatch({ type: IS_LOADING, data: true });

    // DEV
    if (isLocalDebugMode()) {
      const res = {
        data: {
          applicationId: "2409136019647644656",
          redirectionUrl: "https://dev.payflex.my/income-assessment/?source=boost&embedded=1&clientId=4&applicationId=2409136019647644656&lToken=eyJhbGciOiJIUzI1NiJ9.eyJleHBpcnlJbk1pbGxpU2Vjb25kcyI6MTgwMDAwLCJjcmVhdGVUaW1lIjoxNzI2MDMwMzM2Njg5LCJzZWNyZXQiOiI5NTBhT2V2RkhJNGpaRXZjREpTWGt5ZGJLZGJ2YnlOekdkcjdvK2lKZzFRanQzdGZ0VEFtREM4bWYzeWRxYXVlUCtMMVNGaGVydHRpck05ZFl3NWhTMDNhRDRhZ2x4K1hKeWUyd0Vma01oND0ifQ.7wzQMCq1zsy6jMuQdsGp_UlOnAdQ0qh8KorSfmPcES0",
        }
      };
      if (res.data?.redirectionUrl) {
        // add language code &lang=xx
        window.location.assign(`${res.data?.redirectionUrl}&lang=en&returnOnboarding=1`);
      }
      return;
    }

    return api
      .get(`/paylater/income-assessment/url?customerId=${customerId}&applicationId=${applicationId}`, { Authorization: state.sessionToken })
      .then((res) => {
        console.log("getIncomeAssessmentUrl", res);
        if (res.data?.redirectionUrl) {
          // add language code &lang=xx
          window.location.assign(`${res.data?.redirectionUrl}&lang=en&returnOnboarding=1`);
        }
      })
      .catch((error) => {
        console.log("getIncomeAssessmentUrl error", error);
        if (error.status === 403 && reTry) {
          getSessionToken().then((res) => {
            if (res) getIncomeAssessmentUrl(applicationId, customerId, false);
          });
        } else {
          dispatch({ type: IS_LOADING, data: false });
          showErrorDialog(error);
        }
      });
  };

  const handleApplicationStatus = (applicationId, applicationStatus, eligibilityAmount, requireConsentFlag) => {
    // Check applicationStatus to resume journey
    if (applicationStatus == APPLICATION_STATUS.CONSENT_PENDING || applicationStatus == APPLICATION_STATUS.SUCCESS) {
      // Non PayFlex send clevertap event without consent
      if (!requireConsentFlag) {
        // clevertap.event.push("BNPL_ACTIVATED", {});
      }

      dispatch({ type: SET_DATA,
        data: {
          eligibilityAmount: eligibilityAmount,
          requireConsentFlag: requireConsentFlag,
          applicationStatus: applicationStatus,
          step: "ApplicationSubmitted",
        }
      });
    } else if (applicationStatus == APPLICATION_STATUS.MANDATE_APPROVED && applicationId) {
      if (FEATURE_TOGGLE_ENABLE_BOOSTCONNECT_MANDATE) {
        // actions.getMandateStatusv2({ applicationId }, null, false);
        actions.setStep("MandateLoading");
      } else {
        actions.getMandateStatus({ applicationId }, false);
      }
    }
  };

  const getSessionToken = () => {
    console.log({ Authorization: state.kycToken });

    // DEV
    if (isLocalDebugMode()) {
      const res = {
        data: {
          "sessionToken": "abc123",
        }
      };
      state.sessionToken = res.data.sessionToken;
      dispatch({ type: SET_DATA, data: { sessionToken: res.data.sessionToken } });
      return new Promise((resolve) => resolve(true));
    }

    return api.get(`/customer/signin/session?customerId=${state.customerId}`, { Authorization: state.kycToken }).then((res) => {
      // ls.set('sessionToken', res.data.sessionToken);
      state.sessionToken = res.data.sessionToken;
      dispatch({ type: SET_DATA, data: { sessionToken: res.data.sessionToken } });
      return true;
    }).catch((error) => {
      dispatch({ type: IS_LOADING, data: false });
      showErrorDialog(error);
      return false;
    });
  };

  const getTransactionToken = () => {
    dispatch({ type: IS_LOADING, data: true });
    return api.postPartner("/bnpl-gateway/checkout/transaction", { customerId: state.customerId }, { Authorization: state.pToken }).then((res) => {
      console.log("getTransactionToken", res);
      state.transactionToken = res.data.transactionToken;
      state.payment_uuid = res.data.payment_uuid;
      state.orderId = res.data.order_id;
      state.customer = res.data.customer;
      state.merchant = res.data.merchant;
      state.transaction_description = res.data.transaction_description;
      state.ex_merchant_id = res.data.ex_merchant_id;
      state.ex_sub_merchant_id = res.data.ex_sub_merchant_id;
      state.metadata = res.data.metadata;
      state.transaction_api_version = res.data.api_version;

      // online purchase: immediately initiate transaction
      initiateTransaction();
    }).catch((error) => {
      dispatch({ type: IS_LOADING, data: false });
      showErrorDialog(error);
    }).finally(() => {
    });
  };

  const getOfflineTransactionToken = (reTry = true) => {
    dispatch({ type: IS_LOADING, data: true });
    return api.postPartner("/bnpl-gateway/checkout/offline", { customerId: state.customerId, clientId: state.clientId }, { Authorization: state.sessionToken }).then((res) => {
      console.log("getOfflineTransactionToken", res);
      state.transactionToken = res.data.transactionToken;
      // state.payment_uuid = res.data.payment_uuid; // offline no paymentUuid
      state.orderId = res.data.order_id;
      state.customer = res.data.customer;
      state.merchant = res.data.merchant;
      state.transaction_description = res.data.transaction_description;
      state.ex_merchant_id = res.data.ex_merchant_id;
      state.ex_sub_merchant_id = res.data.ex_sub_merchant_id;
      state.metadata = {
        ...res.data.metadata,
        ...state.metadata
      };
      state.transaction_min_amount = res.data.min_amount;
      state.transaction_max_amount = res.data.max_amount;
      state.transaction_api_version = res.data.api_version;

      // offline purchase: redirect to offline UI
      dispatch({ type: SET_DATA, data: { ...state, currentPage: "transaction", step: "OfflinePurchase" } });
    }).catch((error) => {
      console.log("getOfflineTransactionToken error", error);
      if (error.status === 403 && reTry) {
        getSessionToken().then((res) => {
          if (res) getOfflineTransactionToken(false);
        });
      } else {
        dispatch({ type: SET_DATA, data: { step: "Landing" } });
        showErrorDialog(error);
      }
    }).finally(() => {
      dispatch({ type: IS_LOADING, data: false });
    });
  };

  const initiateTransaction = (reTry = true) => {
    dispatch({ type: IS_LOADING, data: true });
    const data = {
      orderId: state.orderId,
      transactionToken: state.transactionToken,
      transactionDescription: state.transaction_description,
      merchantId: state.ex_merchant_id,
      subMerchantId: state.ex_sub_merchant_id,
      metadata: state.metadata,
      amount: state.transactionAmount // for offline purchase
    };
    return api.post(`/paylater/transaction/initiate?customerId=${state.customerId}`, data, { Authorization: state.sessionToken }).then((res) => {
      console.log("initiateTransaction", res);
      state.transaction = res.data;
      state.skipInitiationAgreement = res.data.skipInitiationAgreement;
      if (state.pToken) {
        // online
        updateBnplGatewayPayment();
      } else if (state.pMode == "offline") {
        // offline purchase
        dispatch({ type: SET_DATA, data: { ...state, currentPage: "transaction", step: "PaymentPlan" } });
      }
    }).catch((error) => {
      console.log("initiateTransaction error", error);
      if (error.status === 403 && reTry) {
        getSessionToken().then((res) => {
          if (res) initiateTransaction(false);
        });
      } else {
        if (state.pToken) {
          dispatch({ type: SET_DATA, data: { step: "Landing" } });
        }
        showErrorDialog(error);
      }
    }).finally(() => {
      dispatch({ type: IS_LOADING, data: false });
    });
  };

  const updateBnplGatewayPayment = () => {
    const data = {
      transactionId: state.transaction.transactionId,
      customerId: state.customerId
    };
    return api.putPartner("/bnpl-gateway/checkout/payment", data, { Authorization: state.pToken }).then((res) => {
      console.log("updateBnplGatewayPayment", res);
      dispatch({ type: SET_DATA, data: { ...state, currentPage: "transaction", step: "PaymentPlan" } });
    }).catch((error) => {
      dispatch({ type: IS_LOADING, data: false });
      showErrorDialog(error);
    });
  };

  const createFormPost = (url) => {
    const params = {};
    const urlDestructure = url.split("?");
    const path = urlDestructure[0];
    const queryString = urlDestructure[1];
    const sURLVariables = queryString.split("&");
    for (let i = 0; i < sURLVariables.length; i++) {
      const [sParameterKey, sParameterValue] = sURLVariables[i].split("=");
      params[sParameterKey] = sParameterValue;
    }

    const form = document.createElement("form");
    form.method = "post";
    form.action = path;
    form.enctype = "application/x-www-form-urlencoded";

    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = key;
        hiddenField.value = decodeURIComponent(params[key].replace(/\+/g, " "));
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  };

  return actions;
};
